export default "__VITE_ASSET__CszQ6yce__"